/* global document */

import 'es6-object-assign/auto';

import { defaultTo } from 'lodash';
import arrowIcon from '../../../_img/icons/arrow-down.svg';

import './tabs.scss';
import template from './tabs.vhtml';
//import { historyComponentMixin } from '../../plugins/history';
import { trackPageview } from '../../scripts/tag-manager';

export default {
	template,
	components: {
		arrowIcon,
	},
	props: {
		tabs: {
			type: Array,
			required: true,
		},
		capitalize: {
			type: Boolean,
			default: false,
		},
		trackPageviews: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		selectedTab: 0,
		leftIndicator: false,
		rightIndicator: false,
		scrollLeft: 0
	}),
	methods: {

		determineOverflow(){
			const container = this.$refs.tabsContainer;
			const content = this.$refs.tabsContent;

			var containerMetrics = container.getBoundingClientRect();
			var containerMetricsRight = Math.floor(containerMetrics.right);
			var containerMetricsLeft = Math.floor(containerMetrics.left);
			var contentMetrics = content.getBoundingClientRect();
			var contentMetricsRight = Math.floor(contentMetrics.right) - 2;
			var contentMetricsLeft = Math.floor(contentMetrics.left) + 2;

			if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
				this.leftIndicator = true
				this.rightIndicator = true
			} else if (contentMetricsLeft < containerMetricsLeft) {
				this.leftIndicator = true
				this.rightIndicator = false
			} else if (contentMetricsRight > containerMetricsRight) {
				this.rightIndicator = true
				this.leftIndicator = false
			} else {
				this.leftIndicator = false
				this.rightIndicator = false
			}


		},

		changeTab(index) {
			this.selectedTab = index;
			this.$emit('change-tab', index);
		},

		scrollPrev(){
			const container = this.$refs.tabsContainer
			const content = this.$refs.tabsContent;
            let contentMetrics = content.getBoundingClientRect();
			container.scrollBy({
				left: contentMetrics.width * -1,
				behavior: 'smooth'
			});
		},

		scrollNext(){
			const container = this.$refs.tabsContainer
			let containerMetrics = container.getBoundingClientRect();

			container.scrollBy({
				left: containerMetrics.width * 0.7,
				behavior: 'smooth'
			});
		},
	},
	mounted(){
		this.determineOverflow();
	}
};



// WEBPACK FOOTER //
// ./assets/_js/components/tabs/tabs.js